module.exports = __webpack_public_path__ + "img/8G.290bd808.png";